export type TypeChildFunction = (this: HTMLElement, el: HTMLElement) => HTMLElement | string;

export type TypeChildContent = HTMLElement | string | TypeChildFunction;

// ----------------------------------------------------------------------------

function child(element: HTMLElement, html: TypeChildContent): void {
    // If using function
    if (typeof html === 'function') {
        html = html.call(element, element);
    }

    // If item is element
    if (html instanceof HTMLElement) {
        element.appendChild(html);
    }
    // Is default
    else {
        element.innerHTML = html;
    }
}

// ----------------------------------------------------------------------------

declare global {
    interface HTMLElement {
        child(html: TypeChildContent): HTMLElement;
    }
}

// ----------------------------------------------------------------------------

HTMLElement.prototype.child = function (html: TypeChildContent): HTMLElement {
    child(this, html);

    return this;
};

// ----------------------------------------------------------------------------

export default child;
